const ENVIRONMENTS_COOKIE = "e";

export const addEnvironment = (hostname) => {
  const environments = getEnvironments();

  // Do not add same environment twice
  if (environments.some((env) => env === hostname)) return;

  environments.push(hostname);

  const currentDate = new Date();
  currentDate.setDate(currentDate.getUTCDay() + 365); // Expiry date is a year ahead

  const cookieDomain = location.hostname.split(".").slice(-2).join(".");
  document.cookie = `${ENVIRONMENTS_COOKIE}=${JSON.stringify(
    environments
  )}; expires=${currentDate.toUTCString()}; path=/; domain=${cookieDomain};`;
};

export const getEnvironments = () => {
  const cookies = document.cookie.split(";");
  const envCookie = cookies.find((cookie) => {
    return cookie.trim().startsWith(`${ENVIRONMENTS_COOKIE}=`);
  });

  return envCookie ? JSON.parse(envCookie.split("=")[1]) : [];
};
